import {css} from '@emotion/css';
import {useMemo} from 'react';

import {transitionSpeed} from '../../config/vars';
import {useWolfTheme} from '../../contexts';

const useStyle = (padContent: boolean) => {
    const theme = useWolfTheme();
    return useMemo(
        () => ({
            pageLayout: css({
                display: 'grid',
                gridTemplateRows: 'auto 1fr',
                height: '100dvh',
            }),

            layout: css({
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                gridTemplateRows: '1fr',
                overflow: 'hidden',
                transition: transitionSpeed,
            }),

            navWrapper: css({
                transition: `${transitionSpeed} width`,
            }),

            contentStyles: css({
                display: 'grid',
                gridTemplateRows: '1fr',
                height: '100%',
                overflow: 'hidden',
            }),

            scrollbar: css({
                padding: padContent ? `${theme.orbitalFour} ${theme.orbitalEight}` : '0',
            }),
        }),
        [padContent, theme.orbitalEight, theme.orbitalFour]
    );
};

export default useStyle;
